import { useParams as useReactRouterParams } from "react-router-dom";
import { useNavigation } from "./navigation";
import { useToasts } from "src/components/Toasts";

type ParamTypes = string | number;

export const useParams = <T extends Record<string, ParamTypes>>(): T => {
  const params = useReactRouterParams();
  const { navigate } = useNavigation();
  const { toast } = useToasts();

  const typedParams: Record<string, ParamTypes> = {};

  for (const key in params) {
    const rawValue = params[key];

    if (rawValue === undefined) {
      navigate("/404");
      toast({ title: "Invalid url", type: "ERROR" });
      break;
    }

    // Try to infer numeric values automatically
    const maybeNumber = Number(rawValue);
    typedParams[key] = !isNaN(maybeNumber) && rawValue.trim() !== "" ? maybeNumber : rawValue;
  }

  return typedParams as T;
};
